export class User {

  id:number;

  name:string;

  email:string;

  avatarUrl: string;
  
  selected: boolean = false;
  
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/model/user.ts